import { fetchApi } from "../utils/apiUtils";

// API call function using fetch
export const fetchPartnersList = async (accessToken, page, searchTerm) => {
  const body = {};
  if (searchTerm) {
    body.name = searchTerm;
  }
  return fetchApi('partner/list/?page=' + page,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`, // Explicitly add token
      },
      body,
      requiresAuth: true
    }
  );
}
export const fetchPartnersApi = async (accessToken, nextPageUrl) => {

  const response = await fetchApi(nextPageUrl,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`, // Explicitly add token
      },
      requiresAuth: true
    }
  );
  return await response;
}
export const fetchPartnersFullListApi = async (accessToken) => {

  const response = await fetchApi(`partner/full_list/`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`, // Explicitly add token
      },
      requiresAuth: true
    }
  );
  return await response;
}
export const fetchPartnersDetailApi = async (accessToken, id) => {

  const response = await fetchApi('partner/details/' + id,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`, // Explicitly add token
      },
      requiresAuth: true
    }
  );
  return await response;
}

export const fetchPartnersBasicApi = async (accessToken, id) => {

  const response = await fetchApi(`unified/partner/details/${id}/`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`, // Explicitly add token
      },
      requiresAuth: true
    }
  );
  return await response;
}

export const fetchUserDetailApi = async (accessToken, id) => {

  return await fetchApi(`user/detail/${id}/`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`, // Explicitly add token
      },
      requiresAuth: true
    }
  );

}

export const fetchCustomersApiDropdown = async (accessToken, partnerId, nextPageUrl) => {
  const response = await fetchApi(nextPageUrl,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`, // Explicitly add token
      },
      body: partnerId ? { partner_id: partnerId } : {},
      requiresAuth: true
    }
  );
  return await response
}

export const fetchCustomersApi = async (accessToken, partnerId, page, searchTerm) => {
  const body = {};
  if (partnerId) {
    body.partner_id = partnerId;
  }
  if (searchTerm) {
    body.name = searchTerm;
  }
  return await fetchApi(`partner/customer-list/?page=${page}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`, // Explicitly add token
      },
      body,
      requiresAuth: true
    }
  );
}

export const CustomerEditApi = async (accessToken, id) => {
  return await fetchApi(`partner/customer/detail/${id}/`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    },
    requiresAuth: true

  })
}
export const hanldeUserDeactivate = async (accessToken, id, activeStatus) => {
  return await fetchApi(`user/activate/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    },
    body: {
      "user_list": [Number(id)],
      active_status: activeStatus === true ? "false" : "true"
    },
    requiresAuth: true

  })
}
export const handleCustomerUserFetch = async (accessToken, id, page) => {
  const response = await fetchApi(`partner-customer-user/list/?page=${page}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,

    },
    body: {
      "customer": `${id}`
    },
    requiresAuth: true

  })

  return await response
}
export const handlePartnerUserFetch = async (accessToken, id, page) => {
  const response = await fetchApi(`partner-customer-user/list/?page=${page}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,

    },
    body: {
      "partner_id": `${id}`
    },
    requiresAuth: true

  })

  return await response
}
export const fetchUsersApi = async (accessToken, page, filterQuery) => {

  const payload = {
    name: filterQuery.name,
    user_type: filterQuery.usertype,
    ...(filterQuery.customer && { customer_id: filterQuery.customer }),
  }

  const response = await fetchApi(`partner-customer-user/list/?page=${page}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`, // Explicitly add token
      },
      body: payload,
      requiresAuth: true
    }
  );
  return await response
}
export const fetchUserRolesApi = async (accessToken) => {
  const response = await fetchApi('role/list/with-group/',
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`, // Explicitly add token
      },
      requiresAuth: true
    }
  );
  return await response
}
export const fetchUserTypesApi = async (accessToken) => {
  const response = await fetchApi('user-type/list/',
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`, // Explicitly add token
      },
      requiresAuth: true
    }
  );
  return await response
}

export const createPartnerApi = async (accessToken, partnerData) => {
  try {
    const response = await fetchApi('partner/create/',
      {
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json',
        //   Authorization: `Bearer ${accessToken}`, // Explicitly add token
        // },
        body: partnerData,
        requiresAuth: true
      }
    );
    // if (!response.ok) {
    //     throw new Error(`Error: ${response.status} - ${response.statusText}`);
    // }


    return response;
  } catch (error) {
    console.error('Error submitting CustomerData data:', error);
    return error;
  }

}
export const editPartnerApi = async (accessToken, partnerData, partnerId) => {
  try {

    const response = await fetchApi(`partner/update/${partnerId}/`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
        },

        body: partnerData, // Convert the data to JSON
        requiresAuth: true
      }
    );
    // if (!response.ok) {
    //     throw new Error(`Error: ${response.status} - ${response.statusText}`);
    // }
    const result = response;

    return result;
  } catch (error) {
    return error
  } finally {
    // setLoading(false); // Hide loading indicator
  }

}

export const createCustomerApi = async (accessToken, CustomerData) => {

  const response = await fetchApi(`customer/create/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`,
    },
    body: CustomerData, // Convert the data to JSON
    requiresAuth: true
  });

  // if (!response.ok) {
  //   throw new Error(`Error: ${response.status} - ${response.statusText}`);
  // }
  const result = response;
  // const result = await response.json();
  return result;

}
export const UpdateCustomerApi = async (accessToken, CustomerData, id) => {
  // try {
  return await fetchApi(`customer/update/${id}/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`,
    },
    body: CustomerData, // Convert the data to JSON
    requiresAuth: true
  });

  // if (!response.ok) {
  //   throw new Error(`Error: ${response.status} - ${response.statusText}`);
  // }
  //   const result = response;
  //   // const result = await response.json();
  //   console.log('API Response:', result);
  //   return result;
  // } catch (error) {
  //   return error

  // } finally {
  //   // setLoading(false); // Hide loading indicator
  // }

}
export const createUsersApi = async (accessToken, UsersData) => {

  const response = await fetchApi(`user/create/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`,
    },
    body: UsersData, // Convert the data to JSON
    requiresAuth: true
  });

  // if (!response.ok) {
  //   throw new Error(`Error: ${response.status} - ${response.statusText}`);
  // }

  // const result = await response.json();

  return response;


}
export const updateUsersApi = async (accessToken, UsersData, id) => {

  const response = await fetchApi(`user/update/${id}/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`,
    },
    body: UsersData, // Convert the data to JSON
    requiresAuth: true
  });


  return response;


}
export const updateUsersprofileApi = async (accessToken, UsersData, id) => {

  const response = await fetchApi(`user/update/${id}/`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
    },
    body: UsersData, // Convert the data to JSON
    requiresAuth: true
  });


  return response;


}
export const updateUsersRolesApi = async (accessToken, rolesData) => {

  const response = await fetchApi(`user/role/create/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`,
    },
    body: rolesData, // Convert the data to JSON
    requiresAuth: true
  });

  // if (!response.ok) {
  //   throw new Error(`Error: ${response.status} - ${response.statusText}`);
  // }

  // const result = await response.json();
  const result = response;
  return result;


}

export const fetchTeamsApi = async (accessToken, page) => {

  const response = await fetchApi(`team/team-list/?page=${page}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`, // Explicitly add token
      },
      body: {},
      requiresAuth: true
    }
  );
  return await response
}

export const createTeamApi = async (accessToken, TeamData) => {

  const response = await fetchApi(`team/team-create/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`,
    },
    body: TeamData, // Convert the data to JSON
    requiresAuth: true
  });
  return response;

}

export const fetchTeamDetailApi = async (accessToken, id) => {

  return await fetchApi(`team/team-detail/${id}/`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`, // Explicitly add token
      },
      requiresAuth: true
    }
  );

}

export const fetchAllUsersApi = async (accessToken, page, filterQuery) => {

  const response = await fetchApi(`partner-customer-user/list/?page=${page}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: {},
      requiresAuth: true
    }
  );
  return await response
}

export const createTeamUserApi = async (accessToken, TeamData) => {

  const response = await fetchApi(`team/team-user-create-update/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`,
    },
    body: TeamData, // Convert the data to JSON
    requiresAuth: true
  });
  return response;

}

export const updateTeamApi = async (accessToken, TeamData, id) => {

  const response = await fetchApi(`team/team-update/${id}/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`,
    },
    body: TeamData, // Convert the data to JSON
    requiresAuth: true
  });
  return response;

}

export const deleteTeamApi = async (accessToken, id) => {
  const response = await fetchApi(`team/team-delete/${id}/`,
    {
      method: 'DELETE',
      requiresAuth: true,
    }
  );
  return response;
}